<template>
	<div>
		<Modal v-bind="$attrs" v-on="$listeners" :xIconDisabled="true">
			<template #action>
				<div class="overflow-auto">
					<div class="flex justify-end m-1">
						<div v-if="loading" class="animate-pulse font-bold w-fit m-auto">Loading...</div>
						
						<!-- 閉じる -->
						<SecondaryButton
							text="閉じる"
							class="border-gray-700 px-6"
							@click="closed()"
							:disabled="loading"
						></SecondaryButton>
					</div>
					<div>
						<div class="text-blue-700 font-bold text-center">{{ target.userName }} さんの感想文</div>

						<div v-if="na" class="text-gray-700 font-bold mb-3 text-center text-sm mt-3">
							※閲覧のみ可能
						</div>

						<!-- 差戻理由 -->
						<div v-if="review.sendBack" class="text-gray-700 mt-3">
							<div class="font-bold mb-1 text-xs">差戻理由</div>
							<div class="text-sm p-2 rounded whitespace-pre border-2 border-gray-300 bg-yellow-50 leading-5">{{ review.sendBack }}</div>
						</div>

						<!-- 1、行数 -->
						<div class="flex flex-wrap text-white text-xs justify-center mt-2">
							<div v-for="t in typeList"
							:key="'rt' + t.id"
							class="w-32 text-center m-1"
							:class="[review.type == t.id ? 'bg-light-blue-700' : '', 'bg-gray-400 rounded-md py-1 text-sm font-medium text-white']"
							>
							{{ t.name }}
							</div>
						</div>

						<!-- 2、参加日 -->
						<div v-if="review.type" class="mt-3">
							<div class="text-xs text-gray-700 font-bold mb-1 border-b w-fit border-gray-300">参加日</div>
							<input
								type="date"
								class="border-0 leading-5 focus:text-gray-900 w-full font-bold"
								:disabled="true"
								v-model="review.day"
							/>
						</div>

						<!-- 内容 -->
						<div>
							<!-- タイトル -->
							<div class="text-xs text-gray-700 font-bold mt-3 mb-1 border-b w-fit border-gray-300">タイトル</div>
							<div class="leading-5 w-full font-bold py-2 px-3 mb-3">
								{{ review.title }}
							</div>

							<!-- 気づき -->
							<div v-for="(row, i) in review.note.slice(0, type.num)" :key="'rev'+i" class="mb-3 flex border-b-2 border-gray-300 ">
								<div class="font-bold self-end">{{ i + 1 }}.</div>

								<div class="leading-5 w-full pt-2 pb-0.5 px-2 text-sm whitespace-pre-line ">
									{{row }}
								</div>
							</div>

							<!-- 今後取り組む -->
							<div v-if="([2, 4]).includes(type.id)" class="mt-5">
								<div class="text-sm text-blue-700 font-bold mb-2">◆ 今後取り組む内容</div>

								<div class="leading-5 w-full p-2 text-sm whitespace-pre-line">
									{{ review.photo.note }}
								</div>

								<!-- 添付した写真 -->
								<div class="">
									<a :href="review.photo.photo" :data-lightbox="1" class="">
										<img :src="review.photo.photo" class="w-full max-w-xs max-h-72 object-contain">
									</a>
								</div>
							</div>

							<!-- 申請 -->
							<div class="rounded p-2 border-double border-2 border-yellow-300 my-5 bg-yellow-50">
								<div class="font-bold text-yellow-600">
									承認
								</div>

								<!-- 差戻理由 -->
								<div v-if="review.sendBack" class="text-gray-700">
									<div class="text-xs p-2 rounded whitespace-pre border border-gray-300 leading-5">
										<div class="font-bold mb-2 text-xs">前回の差戻理由</div>
										{{ review.sendBack }}
									</div>
								</div>

								<div class="flex mt-1 text-sm">
									<!-- 1人目 -->
									<div class="flex-1 text-center">
										<p class="text-xs font-bold text-gray-500 mb-1">1人目</p>
										<p class="font-bold text-gray-500">{{ review.approval1 }}</p>
										<p>{{ review.approverName1 }}</p>
										<p class="text-xs">{{ review.approvalDay1 }}</p>
									</div>
									<!-- 2人目 -->
									<div v-if="review.approver2" class="flex-1 text-center">
										<p class="text-xs font-bold text-gray-500 mb-1">2人目</p>
										<p class="font-bold text-gray-500">{{ review.approval2 }}</p>
										<p>{{ review.approverName2 }}</p>
										<p class="text-xs">{{ review.approvalDay2 }}</p>
									</div>
								</div>

								<div v-if="appAuth" class="mt-5 mb-3 mx-1">
									<!-- 承認 -->
									<PrimaryButton
										text="承認する"
										class="whitespace-nowrap w-full mb-5 bg-teal-500"
										:disabled="loading"
										@click="save('承認')"
										:buttonContents="'要'"
									>
										<LoadingIcon v-if="loading" slot="before" class="h-4 w-4 my-auto mr-1 text-white" />
									</PrimaryButton>

									<!-- 差戻 -->
									<div class="rounded p-2 border-2 border-gray-300 bg-white">
										<div class="text-xs font-bold text-gray-700 mb-1">差戻理由</div>

										<textarea
											:rows="1"
											class="border-gray-300 w-full rounded"
											v-model="sendBack"
											:disabled="loading"
										></textarea>

										<PrimaryButton
											text="差戻する"
											class="whitespace-nowrap w-full bg-red-500 mt-3"
											:disabled="loading"
											@click="save('差戻')"
											:buttonContents="'要'"
										>
											<LoadingIcon v-if="loading" slot="before" class="h-4 w-4 my-auto mr-1 text-white" />
										</PrimaryButton>
									</div>
								</div>
							</div>
							<div v-if="na" class="text-gray-700 font-bold mt-5 mb-3 text-center text-sm">
								※閲覧のみ可能
							</div>
						
							<!-- 閉じる -->
							<SecondaryButton
								text="閉じる"
								class="border-gray-700 px-6 mt-3 ml-auto w-fit block"
								@click="closed()"
								:disabled="loading"
							></SecondaryButton>
						</div>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>
<script>

import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import SecondaryButton from '@components/SecondaryButton.vue'
import * as chatwork from '@libs/chatwork'
import * as dialogs from '@libs/dialogs'
import * as utils from '@libs/utils'
import * as backend from '@libs/backend'
import * as moment from 'moment'
import * as image from '@libs/image'

// 最大行数
const max = 30

// 感想文
const ROW = {
    id: null,
    userId: null,
    userName: '',
    type: null,
    title: '',
    status: null,
    point: null,
    // 30個の配列
    note: Array.from({ length: max }, () => ''),
    photo: { note: '', photo: '' },
		approval1: null,
		approverName1: null,
		approvalDay1: null,
		approval2: null,
		approverName2: null,
		approvalDay2: null,
		sendBack: null
}

// 行数
const TYPE_LIST = [
	{ id: 1, name: '20行', num: 20, isAdd: false },
	{ id: 2, name: '20行＋取組み', num: 20, isAdd: true },
	{ id: 3, name: '30行', num: 30, isAdd: false },
	{ id: 4, name: '30行＋取組み', num: 30, isAdd: true },
]

export default {
	components: {
		Modal,
		PrimaryButton,
		SecondaryButton
	},

	props: {
		target: {
			type: Object
		},
		open: {
			type: Boolean,
			default: false
		},
	},

	data() {
		return {
			loading: false,
			reload: 0,
			// 感想文種別
			typeList: utils.clone(TYPE_LIST),
			// 選択した感想文種別
			type: { id: null, name: '', num: null, isAdd: false },
			// 感想文
			review: utils.clone(ROW),
			// 承認権限
			appAuth: false,
			// 承認者番号
			appNum: null,
			// 申請者でも承認者でもない
			na: false,
			// 差戻理由
			sendBack: null
		}
	},

	watch: {
		open() {
			if (!this.open) {
				return
			}
			this.getTarget()
		}
	},

	computed: {
		userId() {
			return this.$store.getters.user.id
		},
	},

	methods: {
		/**
		 * 表示するデータ取得
		 */
		async getTarget() {
			this.loading = true
			this.review = utils.clone(ROW)
			if (this.target && Object.keys(this.target).length) {
				this.appAuth = false
				// 感想文取得
				const res = await backend.searchData('evaluation/getReviewById', { id: this.target.id })
				if (res.data.data && res.data.data.review && (res.data.data.review.status == '申請中' || this.target.item)) {
					const r = res.data.data.review
					this.setReviewNote(res.data.data)
					// 承認者1
					if (r.approver1 == this.userId && r.approval1 == '承認待ち') {
						this.appAuth = true
						this.appNum = 1
					// 承認者2
					} else if (r.approval1 == '承認済み' && r.approver2 == this.userId && r.approval2 == '承認待ち') {
						this.appAuth = true
						this.appNum = 2
					// 承認者でも申請者でもない
					} else if (this.userId != r.userId) {
						this.na = true
					}
				} else {
					await dialogs.showInfoDialog('申請取り消しの可能性あり', '現在、感想文を作成しなおしている可能性があります。一覧に戻ります。')
					this.$emit('getData')
					this.closed()
				}
			}
			this.loading = false
		},

		/**
		 * 感想の行を設定
		 */
		setReviewNote(r) {
			const res = r.review

			res.note = Array.from({ length: max }, () => '')
			const note = r.note

			note.forEach(n => {
				res.note[n.num - 1] = n.note
			})

			// 行数
			const t = this.typeList.find((type) =>{
				return type.id == res.type
			})
			if (t) {
				this.type = t
			}

			// 写真がある場合
			if (res.photo.photo) {
				// imgタグで表示できる形に変換
				res.photo.photo = image.bufferToDataUrl(res.photo.photo)
			}
			this.review = res
		},

		/**
		 * 承認・差戻
		 */
		async save(val) {
			let end = true
			let sendBack = this.sendBack
			try {
				if (val == '承認') {
					// 1人目の場合
					if (this.appNum == 1) {
						// 2人目がいる場合
						if (this.review.approver2) {
							end = false
						}
					}
				} else {
					if (!sendBack) {
						const log = await dialogs.showConfirmDialog('理由は未記入でよろしいですか？', '差戻理由がありませんが、よろしいですか？')
						if (log != 'YES') {
							return
						}
					}
					const name = utils.deleteKana(this.$store.getters.user.user_name)
					if (!sendBack) {
						sendBack = '**理由未記入**'
					}
					sendBack += '\r\n　' + name + '（' + moment().format('YYYY/MM/DD HH:mm') + '）'
					if (this.review.sendBack) {
						sendBack = this.review.sendBack + '\r\n\r\n' + sendBack
					}
				}
				const res = await backend.postData('evaluation/saveApp', { id: this.target.id, userId: this.userId, day: this.review.day, num: this.appNum, val, end, sendBack })
				if (res.data.data) {
					const chat = res.data.data
					if (chat.apiToken && chat.roomId) {
						const message = []
						let log = ''

						if (val == '承認') {
							message.push(`[To:${chat.accountId}] (承認者2) ${chat.userName}さん`)
							message.push(`[info][title]気づき感想文の承認をお願いします[/title]申請者：${this.target.userName}`)
							message.push(`参加日：${this.review.day}`)
							log = '2人目の承認者へ'
						} else {
							message.push(`[To:${chat.accountId}] ${chat.userName}さん`)
							message.push(`[info][title]気づき感想文が差戻されました[/title]参加日：${this.review.day}`)
							log = '申請者に差戻の'
						}
						message.push(`タイトル：${this.review.title}`)
						message.push('')
						message.push(`●感想文申請一覧：${utils.getSystemOrigin()}${process.env.VUE_APP_PUBLICPATH}StampTable?app=1[/info]`)

						try {
							await chatwork.sendChatWorkMssage(
								chat.roomId,
								message.join('\r\n'),
								chat.apiToken
							)

							await dialogs.showSuccessDialog('保存完了・チャット送信完了', '保存しました。また、' + log + 'チャット送信しました。')
						} catch (error) {
							await dialogs.showErrorDialog('チャット送信失敗', 'チャット送信できませんでしたが、承認結果は保存しました。')
						}
					}
				}

				this.$emit('getData')
				this.closed()
			} catch (error) {
				alert('保存に失敗しました。申し訳ございませんが、再度ボタンを押してください。')
			}
		},

		/**
		 * 初期化
		 */
		closed() {
			this.loading = false
			this.appAuth = false
			this.appNum = null
			this.na = false
			this.type = {}
			this.sendBack = ''
			this.$emit('closed')
		},
	}
}

</script>
<style scoped>
textarea {
	field-sizing: content;
}
</style>